<template>
<div>
  <div v-if="isLoadingAddressList || isLoadingAddressListFilter || isLoadingAddressListVerivied">
       <div class="col-md-12 text-center">
            <half-circle-spinner
              :animation-duration="750"
              :size="100"
              color="#1D3354"
              class="mx-auto"
            />
          </div>
    </div>
  <div v-else
       v-for="(item, index) in dataAddress"
       :key="index" >
    <div
      :class="
        mode === 'billing' && globalBillingData.id == item.id
          ? 'card_selected-card'
          : 'card'
      "
      v-if="mode === 'setting' || item.verifiedStatus"
      @click="selecBilling(item)"
    >
      <div
        v-if="mode === 'billing' && globalBillingData.id == item.id"
        class="selected"
      >
        <p>Selected</p>
      </div>
      <div v-if="$route.path === '/form-saf'" class="box box__heading">
        <div class="name">{{ item.label }}</div>
      </div>
      <div v-else class="box box__heading">
        <div class="name">{{ item.label }}</div>
        <div v-if="item.billingStatus" class="category">Billing Address</div>
          <div
            v-if="item.label.toLowerCase() === 'main office'"
            class="category"
          >
            Legal Address
          </div>
        <div v-if="item.verifiedStatus == 1" class="status status__success">
          <img src="@/assets/image/icon/complete-green.svg" alt="icon" />
          Verified
        </div>
        <div v-else class="status status__error">
          <img src="@/assets/image/icon/error-red.svg" alt="icon" />
          Waiting for Verification
        </div>
      </div>
      <div>
        <div class="title" style="font-size: 14px;">{{ item.companyName }}</div>
        <div class="description">
          <p v-if="item.phoneNumber || item.phoneCode"> {{ `+${item.phoneCode}${removeZeroFirstChar(item.phoneNumber)}` }}</p>
          <p v-if="item.npwp" >{{ item.npwp }}</p>
          <p v-if="item.address" >{{ item.address }}</p>
          <p v-if="item.cityName" >{{ item.cityName }}</p>
          <!-- {{ item.districtName }} , {{ item.subdistrictName }}, -->
          <!-- {{ item.cityName }} <br />
          {{ item.countryName }}, {{ item.provinceName }}, -->
          <p v-if="item.countryName">{{ item.countryName ? `${item.countryName},` : '' }} <span v-if="item.postCode">{{ item.postCode }}</span></p>

        </div>
      </div>
      <div class="box box__button">
        <button
          v-if="mode === 'setting'"
          :disabled="mode === 'billing' && globalBillingData.id == item.id"
          class="button__bluesmall"
          @click="editAddress(item)"
        >
          Edit
        </button>
        <button
          v-if="mode === 'setting'"
          :disabled="item.label.toLowerCase() === 'main office'"
          class="button__bluesmall"
          @click="deleteAddress(item.id)"
        >
          Delete
        </button>
        <button
          :disabled="item.billingStatus == 1"
          v-if="
            mode === 'setting' && !item.billingStatus && item.verifiedStatus
          "
          @click="setAsBillingAddress(item.id)"
          class="button__bluesmall"
        >
          Set As Billing Address
        </button>
        <button
          :disabled="globalBillingData.id == item.id"
          v-if="mode === 'billing' && globalBillingData.id !== item.id"
          class="button__bluesmall"
          @click="selecBilling(item)"
        >
          Select
        </button>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    mode: String,
    billingDataGlobal: Object,
    currentPage: Number,
    isFiltering: Boolean
  },
  name: '',
  data () {
    return {
      totalRows: 0,
      perPage: 4,
      globalBillingData: ''
    }
  },
  mounted () {
    // this.fetchAddressList();
    this.checkDataBillingGlobal()
  },
  // created() {
  //   this.$eventHub.$on("fetch-all-address", this.fetchAddressList());
  // },
  // beforeDestroy() {
  //   this.$eventHub.$off("fetch-all-address");
  // },
  computed: {
    dataAddress () {
      let data = ''
      if (this.mode === 'billing') {
        if (this.isFiltering) {
          data = this.addressListVeriviedFilter && this.addressListVeriviedFilter.addresses
        } else {
          data = this.addressListVerivied && this.addressListVerivied.addresses
        }
      } else {
        if (this.isFiltering) {
          data = this.addressListFilter && this.addressListFilter.addresses
        } else {
          data = this.addressList && this.addressList.addresses
        }
      }
      return data
    },
    ...mapGetters({
      addressList: 'address/addressList',
      isLoadingAddressList: 'address/isLoadingAddressList',

      addressListFilter: 'address/addressListFilter',
      isLoadingAddressListFilter: 'address/isLoadingAddressListFilter',

      addressListVerivied: 'address/addressListVerivied',
      isLoadingAddressListVerivied: 'address/isLoadingAddressListVerivied',

      addressListVeriviedFilter: 'address/addressListVeriviedFilter',
      isLoadingAddressListVeriviedFilter: 'address/isLoadingAddressListVeriviedFilter',

      billingAddressGlobal: 'address/billingAddressGlobal'
    })
  },
  methods: {
    removeZeroFirstChar (phoneString) {
      let str = phoneString ? phoneString.toString() : null
      if (phoneString) {
        if (str.charAt(0) === '+') {
          str = str.substring(3) // remove first character
        }

        if (str.charAt(0) === '0') {
          str = str.substring(1) // remove first character
        } else if (str.charAt(0) === '6' && str.charAt(1) === '2') {
          str = str.substring(2)
        }
      }
      return `${str}`
    },
    // async fetchAddressList() {
    //   await this.$store.dispatch("address/FETCH_ALL_ADDRESS", {page: this.currentPage, perPage: this.perPage});
    // },
    selecBilling (item) {
      this.$store.dispatch('address/BILLING_ADDRESS_GLOBAL', item)
    },
    async editAddress (item) {
      await this.$store.dispatch('auth/FETCH_DIAL_COUNTRY_CODE')
      await this.$store.dispatch('settingCompany/FETCH_COUNTRIES')
      this.$eventHub.$emit('dialog-form-address', {
        data: item,
        title: 'Edit Address',
        selected: {
          phoneCode: this.selectedPhoneCode,
          country: this.selectedCountry,
          province: this.selectedProvince,
          city: this.selectedCity,
          district: this.selectedDistrict,
          subdistrict: this.selectedSubdistrict
        },
        currentPage: this.currentPage
      })
    },
    async setAsBillingAddress (id) {
      await this.$store.dispatch('address/SET_BILLING_ADDRESS', id)
      this.fetchAddressList()
    },
    deleteAddress (id) {
      this.$eventHub.$emit('dialog-modal-option', {
        title: 'Delete Address',
        title2: 'Are you sure wants to delete this address ? ',
        modeOption: 'deleteBillingAddress',
        id: id,
        currentPage: this.currentPage
      })
    },
    checkDataBillingGlobal () {
      this.globalBillingData = this.billingAddressGlobal
    }
  },
  watch: {
    addressList (data) {
      if (data) {
        // this.dataAddress = data.addresses;
        this.totalRows = data.totalRecords
      }
    },
    addressListFilter (data) {
      if (data) {
        // this.dataAddress = data.addresses;
        this.totalRows = data.totalRecords
      }
    },
    billingDataGlobal (data) {
      if (data) {
        this.globalBillingData = data
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/AddressCard.vue